/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-dialog-header-padding: Dialog header padding.
 * @prop --sy-dialog-header-title-color: Dialog header title color.
 * @prop --sy-dialog-header-title-font-size: Dialog header title font size.
 * @prop --sy-dialog-header-title-text-decoration: Dialog header title text decoration.
 * @prop --sy-dialog-header-title-font-family: Dialog header title font family.
 * @prop --sy-dialog-header-title-font-weight: Dialog header title font weight.
 * @prop --sy-dialog-header-title-font-style: Dialog header title font style.
 * @prop --sy-dialog-header-title-font-stretch: Dialog header title font stretch.
 * @prop --sy-dialog-header-title-letter-spacing: Dialog header title letter spacing.
 * @prop --sy-dialog-header-title-line-height: Dialog header title line height.
 * @prop --sy-dialog-header-dismiss-color: Dialog dismiss button icon color.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: flex;
  justify-content: space-between;
  padding: var(--sy-dialog-header-padding, var(--sy-spacer-4));
}
:host .sy-dialog-title {
  color: var(--sy-dialog-header-title-color, var(--sy-foreground-high-emphasis));
  font-size: var(--sy-dialog-header-title-font-size, var(--sy-heading-h5-font-size));
  text-decoration: var(--sy-dialog-header-title-text-decoration, var(--sy-heading-h5-text-decoration));
  font-family: var(--sy-dialog-header-title-font-family, var(--sy-heading-h5-font-family));
  font-weight: var(--sy-dialog-header-title-font-weight, var(--sy-heading-h5-font-weight));
  font-style: var(--sy-dialog-header-title-font-style, var(--sy-heading-h5-font-style));
  font-stretch: var(--sy-dialog-header-title-font-stretch, var(--sy-heading-h5-font-stretch));
  letter-spacing: var(--sy-dialog-header-title-letter-spacing, var(--sy-heading-h5-letter-spacing));
  line-height: var(--sy-dialog-header-title-line-height, var(--sy-heading-h5-line-height));
}
:host .sy-dismiss {
  --sy-dismiss-color: var(--sy-dialog-header-dismiss-color, var(--sy-foreground-medium-emphasis));
  --sy-dismiss-background-color-hover: var(--sy-surface-elevated-hover);
}